<template>
  <div class="demo">
    <SjButton @click="openDialog">打开弹窗</SjButton>
    <SjDialog
      title="进度"
      :visible="visible"
      @close="handleClose"
      @confirm="handleConfirm"
    >
      <SjProcedureProgress v-model="currentProgress">
        <SjProcedure
          ><template v-slot="{ step }"
            ><ProcedureCard
              :text="'0'"
              :active="step > 0"
            ></ProcedureCard></template
        ></SjProcedure>
        <SjProcedure
          ><template v-slot="{ step }"
            ><ProcedureCard
              :text="'1'"
              :active="step > 1"
            ></ProcedureCard></template
        ></SjProcedure>
        <SjProcedure
          ><template v-slot="{ step }"
            ><ProcedureCard
              :text="'2'"
              :active="step > 2"
            ></ProcedureCard></template
        ></SjProcedure>
        <SjProcedure
          ><template v-slot="{ step }"
            ><ProcedureCard
              :text="'3'"
              :active="step > 3"
            ></ProcedureCard></template
        ></SjProcedure>
      </SjProcedureProgress>
    </SjDialog>
  </div>
</template>

<script>
import ProcedureCard from "./ProcedureCard";
import { setInterval, clearInterval } from "timers";
export default {
  components: {
    ProcedureCard
  },
  data() {
    return {
      visible: false,
      currentProgress: 0,
      interval: null
    };
  },
  methods: {
    openDialog() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
    handleConfirm() {
      this.visible = false;
    }
  },
  created() {
    this.interval = setInterval(() => {
      this.currentProgress++;
      if (this.currentProgress === 4) {
        this.currentProgress = 0;
      }
    }, 4000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<style scoped lang="less">
.demo {
  > * {
    margin-bottom: 10px;
  }
}
</style>
